/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Template_Category_PropertiesInputs */

const cs_automation_template_category_properties = /** @type {(inputs: Automation_Template_Category_PropertiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitosti`)
};

const en_automation_template_category_properties = /** @type {(inputs: Automation_Template_Category_PropertiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties`)
};

/**
* | output |
* | --- |
* | "Properties" |
*
* @param {Automation_Template_Category_PropertiesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_template_category_properties = /** @type {((inputs?: Automation_Template_Category_PropertiesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Template_Category_PropertiesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_template_category_properties(inputs)
	return cs_automation_template_category_properties(inputs)
});